import PropTypes from 'prop-types';
import { path } from 'ramda';
import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';

import { connect } from 'react-redux';
import { createResource } from 'redux-json-api';
import { SubmissionError } from 'redux-form';

import { closeLeftBarModule, showSnackbarMessage } from '../../modules/actions/layout';
import CompanyForm from './Form';

class CompanyAdd extends Component {
  static propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    createResource: PropTypes.func.isRequired,
    closeLeftBarModule: PropTypes.func.isRequired,
    showSnackbarMessage: PropTypes.func.isRequired,
  };

  render() {
    const { apiEndpoint, createResource, closeLeftBarModule, showSnackbarMessage } = this.props;

    return (
      <Grid fluid>
        <Row>
          <Col style={{ margin: 20, width: '100%' }}>
            <CardHeader title="Bedrijf toevoegen" />

            <Divider />

            <CompanyForm
              onSubmit={async (values) => {
                try {
                  const entity = {
                    type: 'company',
                    attributes: {
                      'name': values.name,
                      'address': values.address,
                      'zipcode': values.zipcode,
                      'city': values.city,
                      'country': values.country,
                      'phone': values.phone,
                      'phone-24h': values.phone_24h,
                      'email': values.email,
                      'website': values.website,
                      'bank-account': values.bank_account,
                      'kvk-number': values.kvk_number,
                    },
                  };

                  if (values.phone_24h_2) entity['phone-24h-2'] = values.phone_24h_2;

                  /**
                   * Optionally set `serviced-railways`.
                   */
                  if (values.serviced_railways && values.serviced_railways.constructor === Array) {
                    entity['serviced-railways'] = values.serviced_railways.map(r => `${apiEndpoint}/railway/${r}`);
                  }

                  await createResource(entity);
                  closeLeftBarModule('company');
                  showSnackbarMessage('Bedrijf toegevoegd');
                } catch (exc) {
                  let errors = {};
                  const res = await exc.response.json();

                  res.errors.forEach(e => {
                    const field = path(['source', 'pointer'], e)
                      .replace('/data/attributes/', '')
                      .replace('-', '_');

                    if (field === 'non_field_errors') errors._error = e.detail;
                    else {
                      errors[field] = e.detail;

                      switch (field) {
                        case 'name': {
                          errors[field] += ' (voorbeeld: Arriva Touring)';
                          break;
                        }
                        case 'address': {
                          errors[field] += ' (voorbeeld: Bornholmstraat 60)';
                          break;
                        }
                        case 'zipcode': {
                          errors[field] += ' (voorbeeld: 9723 AZ)';
                          break;
                        }
                        case 'city': {
                          errors[field] += ' (voorbeeld: Groningen)';
                          break;
                        }
                        case 'country': {
                          errors[field] += ' (kies een land uit de lijst)';
                          break;
                        }
                        case 'phone': {
                          errors[field] += ' (voorbeeld: 050 526 0268)';
                          break;
                        }
                        case 'phone_24h': {
                          errors[field] += ' (voorbeeld: 06 12345678)';
                          break;
                        }
                        case 'phone_24h_2': {
                          errors[field] += ' (voorbeeld: 06 12345678)';
                          break;
                        }
                        case 'email': {
                          errors[field] += ' (voorbeeld: info@arrivatouring.nl)';
                          break;
                        }
                        case 'website': {
                          errors[field] += ' (voorbeeld: https://www.arrivatouring.nl)';
                          break;
                        }
                        case 'bank_account': {
                          errors[field] += ' (voorbeeld: NL54RABO0383008336)';
                          break;
                        }
                        case 'kvk_number': {
                          errors[field] += ' (voorbeeld: 12345678)';
                          break;
                        }
                      }
                    }
                  });

                  showSnackbarMessage('Er is iets fout gegaan bij het toevoegen van het bedrijf.');

                  throw new SubmissionError(errors);
                }
              }}
            />
          </Col>
        </Row>
      </Grid>
    );
  };
};

const mapStateToProps = (state) => ({
  apiEndpoint: path(['api', 'endpoint', 'axiosConfig', 'baseURL'], state),
});

const mapDispatchToProps = {
  createResource,
  closeLeftBarModule,
  showSnackbarMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyAdd);
